import _ from 'lodash';
import axios from 'axios';
import { flattenDeep } from 'lodash';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { PlusOutlined } from '@ant-design/icons';
import { decode as base64_decode } from 'base-64';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Form,
  message,
  Select,
  Divider,
  Space,
  Row,
  Col,
  Input,
  DatePicker,
  Tooltip,
  Tree,
  Modal,
  Button,
  Typography
} from 'antd';
import {
  getSitesList,
  // getLocationByAsset,
  submitMaster,
  getDeviceList,
  questionsListMaster,
  getinspectionAreaList,
  getinspectionItemList,
  getAnswersList,
  getWorkPlanningList,
  saveQuestionData,
  saveAreaData,
  saveItemData,
  getEquipmentRecord,
  getMasterById,
  getEquipmentHierarchy,
  getInspectionData,
  getUsersList,
  getStatusListPM
} from '../../../Utils/FormCalls';
import {
  API_DEVICE,
  API_INSPECTIONCONFIG,
  API_INSPECTIONQUESTIONS
} from '../../../../../commons/api';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { StyledHomepageSides } from '../../../../../commons/styles/layout';
import { StyledBox, StyledBoxLabel } from '../../../CSS/style';

const { Option } = Select;
const type = 'Item';
const urlList = {
  insert: API_INSPECTIONCONFIG.INSERT,
  delete: 'api/masterItems/getById?Id=3',
  getbyId: API_INSPECTIONCONFIG.GetById,
  qInsert: API_INSPECTIONQUESTIONS.INSERT
};
const fileData = new FormData();

const QuestionMasterForm = (props) => {

  const [formObject, setFormObject] = useState(props.formObject || {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [usersList, setUsersList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [inspectionAreaList, setInspectionAreaList] = useState([]);
  const [inspectionItemList, setInspectionItemList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [AnswerList, setAnswerList] = useState([]);
  const [WorkPlanList, setWorkPlanList] = useState([]);
  const [viewQuestionModal, setViewQuestionModal] = useState(false);
  // const [ViewModal, setViewModal] = useState(false);
  const [viewAreaModal, setViewAreaModal] = useState(false);
  const [viewItemModal, setViewItemModal] = useState(false);
  const [, setEquipmentRecord] = useState([]);
  const [answerKey, setAnswerKey] = useState([]);
  const [formObjectId, setFormObjectId] = useState('');
  const [formObjectQuestions, setFormObjectQuestions] = useState({});
  const [, setIsNewRecord] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [userId, setUserId] = useState('');
  const InspectionMastersRef = useRef();
  const QuestionRef = useRef();
  const deviceRef = useRef();
  const areaRef = useRef();
  const ItemRef = useRef();
  const searchInput = useRef(null);
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  console.log(windowHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (windowWidth < 768) {
    containerStyle.flexDirection = 'column';
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        let sitesList = await getSitesList();
        let WorkPlanList = await getWorkPlanningList();
        let questionList = await questionsListMaster();
        let inspectionAreaList = await getinspectionAreaList();
        let inspectionItemList = await getinspectionItemList();
        let AnswerList = await getAnswersList();
        let statusList = await getStatusListPM();
        let deviceList = await getDeviceList();
        let usersList = await getUsersList();

        let userId = props.userProfile?.user?.Id || '';
        setUserId(userId);
        let formObject = InspectionMastersRef.current.getFieldsValue();
        formObject = {
          ...formObject,
          SiteId: sitesList[0]?.Id || ''
        };
        InspectionMastersRef.current.setFieldsValue(formObject);
        await _getDataById();
        setQuestionList(questionList);
        setInspectionItemList(inspectionItemList);
        setAnswerList(AnswerList);
        setDeviceList(deviceList);
        setInspectionAreaList(inspectionAreaList);
        setWorkPlanList(WorkPlanList);
        setTranslationCache(props.translationCache);
        setUsersList(usersList);
        // setFormObject(formObject);
        setStatusList(statusList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setTranslationCache(props.translationCache);
    if (formObject && Object.keys(formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (formObject && Object.keys(formObject).length === 0) {
      if (InspectionMastersRef.current) {
        InspectionMastersRef.current.setFieldsValue(formObject);
      }
    }
  }, [translationCache]);

  const _getDataById = async (Id) => {

    let formObject = {};
    let hierarchyList = [];
    let path = props.location.pathname.split('/rubus/AMM/InspectionMasterDetails/');
    let formId = base64_decode(path[1]);
    let data = {};
    if (formId !== 'new') {
      data = await getMasterById(urlList.getbyId, base64_decode(path[1]), 'GET');
      hierarchyList = await getEquipmentHierarchy(formId);
      formObject = data;
    } else if (Id) {
      data = await getMasterById(urlList.getbyId, Id, 'GET');
      hierarchyList = await getEquipmentHierarchy(Id);
      formObject = data;
    }
    formObject = _.cloneDeepWith(data, (value, key) => {
      if (key === 'CreatedDate') {
        if (value) {
          return dayjs.utc(value, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone);
        } else {
          return null;
        }
      }
      return undefined;
    });

    setFormObject(formObject);
    // setHierarchyList(hierarchyList);
    setTreeData(hierarchyList);
    setFormObjectId(formObject.Id || '');
    if (formObject) {
      InspectionMastersRef.current.setFieldsValue(formObject);
    }
  };

  const onAnswerChange = () => {
    setAnswerKey(answerKey);
  };

  const onInspecFormSubmit = async (values) => {
    let payload = {
      ...formObjectQuestions,
      ...values,
      ...(formObjectId ? { InspectionId: formObjectId } : ''),
      SiteId: localStorage.get('currentSite')
    };
    let statusResponse = await submitMaster(urlList.qInsert, payload, fileData, type);
    if (statusResponse && statusResponse.message) {
      message.success(statusResponse.message.message);
      getEquipmentHierarchyData(payload.InspectionId);
      onReset();
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onFormSubmit = async (values) => {
    let payload = {
      ...formObject,
      ...values,
      ...(formObject && formObjectId ? { Id: formObjectId } : ''),
      ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
      ...(formObjectId ? { UpdatedBy: userId } : {}),
      SiteId: localStorage.get('currentSite')
    };

    let statusResponse = await submitMaster(urlList.insert, payload, fileData, type);
    if (statusResponse && statusResponse.message) {
      message.success(statusResponse.message);
      _getDataById(statusResponse.Id);
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    if (QuestionRef.current) QuestionRef.current.resetFields();
    setFormObjectQuestions({});
  };

  const onDrawerCancel = () => {
    setVisible(false);
  };

  const onModalOk = () => {
    setVisible(false);
  };

  // const onChangeQuestion = () => {
  //   let updatedFormObjectQuestions = QuestionRef.current.getFieldsValue();
  //   setFormObjectQuestions(updatedFormObjectQuestions);
  //   QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
  // };

  // const openCollapse = () => {
  //   setOpen(true);
  // };

  const onAreaClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setViewAreaModal(false);
      areaRef.current.resetFields();
    }
  };

  const onFormAreaSubmit = async (e) => {
    e.preventDefault();
    areaRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          data: { ...values },
          MasterCode: 'Inspection_Areas',
          ActionType: 'create',
          Type: 'WithSiteId'
        };
        let CreateArea = await saveAreaData(payload);
        if (CreateArea) {
          message.success(CreateArea.message);
          let updatedInspectionAreaList = await getinspectionAreaList();
          setInspectionAreaList(updatedInspectionAreaList);
          setViewAreaModal(false);
          if (areaRef.current) areaRef.current.resetFields();
          let updatedFormObjectQuestions = QuestionRef.current.getFieldsValue();
          let areaId = updatedInspectionAreaList.filter((item) => item.Area === values.Area);
          if (areaId && areaId[0]) {
            updatedFormObjectQuestions = {
              ...updatedFormObjectQuestions,
              AreaId: areaId[0].Id
            };
            QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
            setFormObjectQuestions(updatedFormObjectQuestions);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onItemClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setViewItemModal(false);
      if (ItemRef.current) ItemRef.current.resetFields();
    }
  };

  const onFormItemSubmit = async (e) => {
    e.preventDefault();
    ItemRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          MasterCode: 'Inspection_Items',
          ActionType: 'create',
          Type: 'WithSiteId',
          data: {
            ...values
          }
        };
        let CreateItemData = await saveItemData(payload);
        if (CreateItemData) {
          message.success(CreateItemData.message);
          let updatedInspectionItemList = await getinspectionItemList();
          setInspectionItemList(updatedInspectionItemList);
          setViewItemModal(false);
          if (ItemRef.current) ItemRef.current.resetFields();
          let updatedFormObjectQuestions = QuestionRef.current.getFieldsValue();
          let itemId = updatedInspectionItemList.filter((item) => item.Item === values.Item);
          if (itemId && itemId[0]) {
            updatedFormObjectQuestions = {
              ...updatedFormObjectQuestions,
              ItemId: itemId[0].Id
            };
            QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
            setFormObjectQuestions(updatedFormObjectQuestions);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const adQuestionForm = () => {
    setViewQuestionModal(true);
    if (deviceRef.current) deviceRef.current.resetFields();
  };

  // const addAnswerModal = () => {
  //   setViewModal(true);
  //   if (optionRef.current) optionRef.current.resetFields();
  // };

  const onQuestionsClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setViewQuestionModal(false);
    }
  };

  // const onModalClose = (e) => {
  //   if (e.target.tagName === 'DIV') {
  //     e.preventDefault();
  //     message.error('Please Click On Cancel');
  //   } else {
  //     setVisible(true);
  //   }
  // };

  const onModalFormSubmit = async () => {
    deviceRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          ...values
        };
        let createDeviceResponse = await saveQuestionData(payload);

        if (createDeviceResponse) {
          message.success(createDeviceResponse.message.message);
          let updatedQuestionList = await questionsListMaster();
          let updatedFormObjectQuestions = QuestionRef.current.getFieldsValue();
          let questionId = updatedQuestionList.filter((item) => item.Question === values.Question);
          updatedFormObjectQuestions = {
            ...updatedFormObjectQuestions,
            QuestionIds: [
              ...(updatedFormObjectQuestions?.QuestionIds || []),
              questionId[0]?.Id
            ]
          };
          QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
          setFormObjectQuestions(updatedFormObjectQuestions);
          setViewQuestionModal(false);
          setQuestionList(updatedQuestionList);
          setVisible(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onHandleChange = async (e, type) => {
    let form = QuestionRef.current.getFieldsValue();

    let updatedFormObjectQuestions = {
      ...form
    };
    let payload = {
      AreaId: updatedFormObjectQuestions.AreaId,
      ItemId: updatedFormObjectQuestions.ItemId
    };

    if (type === 'ItemId') {
      let equipmentRecordResponse = await getEquipmentRecord(payload);
      // let id = equipmentRecordResponse && equipmentRecordResponse[0] && equipmentRecordResponse[0].Id;

      setEquipmentRecord(equipmentRecordResponse);
      // setGetById(id);

      updatedFormObjectQuestions = {
        ...updatedFormObjectQuestions,
        QuestionIds: equipmentRecordResponse && equipmentRecordResponse &&
          equipmentRecordResponse[0] ? equipmentRecordResponse[0].QuestionIds : []
      };

      setFormObjectQuestions(updatedFormObjectQuestions);
    }

    QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
    setFormObjectQuestions(updatedFormObjectQuestions);
  };
  // const getHierarchyLevels = async () => {
  //   const siteId = localStorage.get('currentSite');
  //   let payload = {
  //     HierarchyCode: hierarchyList[0]?.HierarchyCode || null,
  //     Type: 'Device'
  //   };
  //   const accessToken = localStorage.get('accessToken');
  //   let headers = {
  //     method: 'GET',
  //     url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${payload.HierarchyCode}&Type=${payload.Type}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   return axios(headers)
  //     .then(({ data }) => {
  //       if (Array.isArray(data)) {
  //         setTreeData(data);
  //         setVisible(true);
  //         setFormObjectQuestions(InspectionMastersRef.current.getFieldsValue());
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setDeviceList(data);
        setVisible(true);
        setFormObjectQuestions(QuestionRef.current.getFieldsValue());
      })
      .catch(function () { });
  };

  const TableDropdownChange = (value) => {
    let updatedFormObjectQuestions = QuestionRef.current.getFieldsValue();
    updatedFormObjectQuestions = {
      ...updatedFormObjectQuestions,
      Equipment: value.AliasCode,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode
    };
    setFormObjectQuestions(updatedFormObjectQuestions);
    setVisible(false);
    QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const getEquipmentHierarchyData = async (Id) => {
    let treeData = await getEquipmentHierarchy(Id);
    if (treeData) {
      expandAll(treeData);
    }
    setTreeData(treeData);
    setFormObjectQuestions({});
    setFormObjectId(Id);
  };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <Tree.TreeNode
              title={item && !item.ParentId ? `${item.DisplayCode ? item.DisplayCode : ""}(${item.Name})` : item.Name}
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children, item)}
            </Tree.TreeNode>
          );
        }
        return <Tree.TreeNode key={item.key} title={<div>{item.Name}</div>} dataRef={item} />;
      })
    );
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const expandAll = async (treeData) => {
    let expandedKeys = await getAllKeys(treeData);
    setExpandedKeys(expandedKeys);
  };

  const getAllKeys = (data) => {
    const nestedKeys =
      data &&
      Array.isArray(data) &&
      data.map((node) => {
        let childKeys = [];
        if (node.children) {
          childKeys = getAllKeys(node.children);
        }
        return [childKeys, node.key];
      });
    return flattenDeep(nestedKeys);
  };

  const onSelect = async (selectedKeys, info) => {
    let status =
      info &&
      info['selectedNodes'] &&
      info['selectedNodes'][0] &&
      info['selectedNodes'][0]['dataRef'] &&
      info['selectedNodes'][0]['dataRef']['Type'] &&
      info['selectedNodes'][0]['dataRef']['Type'] === 'Items';

    if (status) {
      let updatedFormObjectQuestions = {};
      let dataRef = info['selectedNodes'][0]['dataRef'];

      let questionPayload = {
        Equipment: dataRef['MainParentId'] || '',
        AreaId: dataRef['ParentId'] ? parseInt(dataRef['ParentId']) : '',
        ItemId: dataRef['Code'] || '',
        InspectionId: formObjectId
      };

      let data = await getInspectionData(questionPayload);
      if (data && data[0]) {
        updatedFormObjectQuestions = data[0];
        setFormObjectQuestions(updatedFormObjectQuestions);
        if (updatedFormObjectQuestions) {
          QuestionRef.current.setFieldsValue(updatedFormObjectQuestions);
        }
      }
    } else if (status === false) {
      message.error('Please Select Item');
    }
  };

  const setNewRecord = async () => {
    onReset();
    // setFormObject({});
    setIsNewRecord(true);
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };
  
  const leftPaneStyle = {
    borderRight: windowWidth >= 768 ? '1px dashed #ccc' : 'none',
    // borderBottom: windowWidth < 768 ? '1px dashed #ccc' : 'none',
    width: windowWidth >= 768 ? '30%' : '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 100px)', // Use vh units for better height management
    boxSizing: 'border-box',
    padding: '10px',
    height: windowHeight - 350 > 300 ? windowHeight - 350 : 300, // minimum height for usability
  };

  const leftHeaderStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '10px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    paddingBottom: '10px',
  };

  const rightPaneStyle = {
    // width: windowWidth >= 768 ? '50%' : '100%',
    // flexGrow: 1,
    // padding: '10px',
    // borderLeft: windowWidth >= 768 ? '3px dashed' : 'none',
    // borderTop: windowWidth < 768 ? '3px dashed' : 'none',
    // opacity: formObjectId && formObjectId !== '' ? 1 : 0.75,
    // pointerEvents: formObjectId && formObjectId !== '' ? 'auto' : 'none',
    // boxSizing: 'border-box',
    width: windowWidth >= 768 ? '70%' : '100%',
    padding: '20px 15px',
    borderLeft: windowWidth >= 768 ? '3px dashed #ccc' : 'none',
    borderTop: windowWidth < 768 ? '3px dashed #ccc' : 'none',
    opacity: formObjectId && formObjectId !== '' ? 1 : 0.6,
    pointerEvents: formObjectId && formObjectId !== '' ? 'auto' : 'none',
    boxSizing: 'border-box',
    maxHeight: 'calc(100vh - 100px)', // keep form area within viewport
    overflowY: 'auto',
    filter: formObjectId && formObjectId !== '' ? 'none' : 'grayscale(0.5)', // subtle disabled effect
    transition: 'opacity 0.3s ease, filter 0.3s ease',
  };

  const treeContainerStyle = {
    flexGrow: 1,
    overflowY: 'auto',
    paddingRight: '10px',
    paddingLeft: '10px',
  };

  const formItemStyle = {
    width: '100%',
    minWidth: '0',  // fix flexbox shrinking issues on small screens
  };

  const formButtonWrapper = {
    marginTop: '20px',
    display: 'flex',
    justifyContent: windowWidth >= 768 ? 'flex-start' : 'center',
    paddingLeft: windowWidth >= 768 ? '250px' : '0',
  };

  return (
    <StyledHomepageSides>
      <Form
        name="InspectionMasters"
        ref={InspectionMastersRef}
        onFinish={(data) => onFormSubmit(data)}
        initialValues={formObject}
        layout="vertical"
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type='primary' htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <StyledBox>
          <Form.Item
            label={translation(translationCache, constant.InspectionId)}
            name="InspectionId"
            rules={[{ required: true }]}
          >
            <InputComponent
              disabled={formObject?.Id ? true : false}
              style={{ width: '100%' }}
              placeholder={translation(translationCache, 'Input Inspection Id')}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.InspectionDesc)}
            name="Description"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '100%' }}
              placeholder={translation(translationCache, 'Input Inspection Description')}
            />
          </Form.Item>
          <Form.Item
            value={userId}
            label={translation(translationCache, constant.createdBy)}
            name="CreatedBy"
          >
            <Select
              style={{ width: '100%' }}
              placeholder={translation(translationCache, constant.CreatedBy)}
              disabled={true}
            >
              {usersList &&
                Array.isArray(usersList) &&
                usersList.map((user, index) => {
                  return (
                    <Option key={index} value={user.Id}>
                      {user.FirstName}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.createdDate)}
            name="CreatedDate"
          >
            <DatePicker
              placeholder={translation(translationCache, constant.createdDate)}
              format="YYYY-MM-DD HH:mm:ss"
              inputReadOnly={true}
              style={{ width: '100%' }}
              disabled={true}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.status)}
            name="Status"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Status')}
              style={{ width: '100%' }}
            >
              {statusList &&
                Array.isArray(statusList) &&
                statusList.map((status, index) => {
                  return (
                    <Option key={index} value={status.Value}>
                      {translation(translationCache, status.Key)}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </StyledBox>
      </Form>

      <StyledBoxLabel >
        <Typography.Title level={5}>
          {translation(props.translationCache, 'Mapping Questions')}
        </Typography.Title>
      </StyledBoxLabel>
      <div>
        <Tooltip
          color={formObjectId && formObjectId !== '' ? '#1a3652' : 'black'}
          title={translation(
            translationCache,
            formObjectId && formObjectId !== '' ? '' : constant.enabledAfterSubmit
          )}
        >
          <div style={containerStyle}>
            <div style={leftPaneStyle}>
              <div style={leftHeaderStyle}>
                <Button
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setNewRecord();
                  }}
                  type="primary"
                  icon={<PlusOutlined />}
                >
                  {translation(translationCache, 'Add')}
                </Button>
              </div>

              <div style={treeContainerStyle}>
                <Tree
                  onExpand={onExpand}
                  expandedKeys={expandedKeys}
                  style={{ width: '100%' }}
                  onSelect={onSelect}
                  showLine
                  defaultExpandAll={true}
                  switcherIcon={<DownOutlined />}
                >
                  {renderTreeNodes(treeData)}
                </Tree>
              </div>
            </div>
            <div style={rightPaneStyle}>
              <Form
                name="InspectionMastersTree"
                ref={QuestionRef}
                className="collapse"
                onFinish={(data) => onInspecFormSubmit(data)}
                layout="horizontal"
                labelCol={{ flex: windowWidth >= 768 ? '250px' : '120px' }}
                labelAlign="right"
                labelWrap
                validateMessages={validateMessages}
              >
                <div
                  disabled={!(formObjectId && formObjectId !== '')}
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px',
                    justifyContent: 'flex-start',
                  }}
                >
                  <Form.Item
                    style={formItemStyle}
                    label={translation(translationCache, constant.equipment)}
                    name="DisplayCode"
                    rules={[{ required: true }]}
                  >
                    <InputComponent
                      disabled={true}
                      suffix={
                        <DownOutlined
                          style={{
                            color: '#1a3b5c'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            getDeviceData('visible');
                          }}
                        />
                      }
                      style={{ width: '100%' }}
                      placeholder={translation(
                        translationCache,
                        `Select ${constant.equipment}`
                      )}
                    />
                  </Form.Item>
                  <Form.Item
                    style={formItemStyle}
                    label={translation(translationCache, constant.inspectionArea)}
                    name="AreaId"
                    rules={[{ required: true }]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      placeholder={translation(translationCache, 'Select Inspection Area')}
                      onSelect={(e) => onHandleChange(e, 'AreaId')}
                      showArrow={true}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: '8px 0'
                            }}
                          />
                          <Space
                            style={{
                              padding: '0 8px 4px'
                            }}
                          >
                            <Button
                              type="dashed"
                              icon={<PlusOutlined />}
                              onClick={() => setViewAreaModal(true)}
                            >
                              {translation(translationCache, constant.addArea)}
                            </Button>
                          </Space>
                        </>
                      )}
                    >
                      {inspectionAreaList &&
                        Array.isArray(inspectionAreaList) &&
                        inspectionAreaList.map((area, index) => {
                          return (
                            <Option key={index} value={area.Id}>
                              {translation(translationCache, area.Area)}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    style={formItemStyle}
                    className="label"
                    label={translation(translationCache, constant.inspectionItems)}
                    name="ItemId"
                    rules={[{ required: true }]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      placeholder={translation(translationCache, 'Select Inspection Items')}
                      onSelect={(e) => onHandleChange(e, 'ItemId')}
                      showArrow={true}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: '8px 0'
                            }}
                          />
                          <Space
                            style={{
                              padding: '0 8px 4px'
                            }}
                          >
                            <Button
                              type="dashed"
                              icon={<PlusOutlined />}
                              onClick={() => setViewItemModal(true)}
                            >
                              {translation(translationCache, constant.addItems)}
                            </Button>
                          </Space>
                        </>
                      )}
                    >
                      {inspectionItemList &&
                        Array.isArray(inspectionItemList) &&
                        inspectionItemList.map((device, index) => {
                          return (
                            <Option key={index} value={device.Id}>
                              {translation(translationCache, device.Item)}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    style={formItemStyle}
                    label={translation(translationCache, constant.question)}
                    name="QuestionIds"
                    rules={[{ required: true }]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      mode="multiple"
                      placeholder={translation(translationCache, 'Select Question')}
                      showArrow={true}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: '8px 0'
                            }}
                          />
                          <Space
                            style={{
                              padding: '0 8px 4px'
                            }}
                          >
                            <Button
                              type="dashed"
                              icon={<PlusOutlined />}
                              onClick={adQuestionForm}
                            >
                              {translation(translationCache, 'Add Question')}
                            </Button>
                          </Space>
                        </>
                      )}
                    >
                      {questionList &&
                        Array.isArray(questionList) &&
                        questionList.map((question, index) => {
                          return (
                            <Option key={index} value={question.Id}>
                              {translation(translationCache, question.Question)}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </div>

                <Form.Item style={formButtonWrapper} >
                  {formObjectQuestions?.Id ? (
                    <Button type="primary" htmlType="submit">
                      {translation(translationCache, 'Update')}
                    </Button>
                  ) : (
                    <Button type="primary" htmlType="submit">
                      {translation(translationCache, 'Save')}
                    </Button>
                  )}
                </Form.Item>
                <Form.Item name="Id"></Form.Item>
                <Form.Item name="Equipment"></Form.Item>
              </Form>

              <Modal
                title={translation(translationCache, 'Add Item')}
                open={viewItemModal}
                okText={'Save'}
                onOk={onFormItemSubmit}
                onCancel={onItemClose}
                bodyStyle={{ padding: '20px' }}
                style={{ maxWidth: '90vw', width: '400px' }}
              >
                <Form
                  layout="vertical"
                  ref={ItemRef}
                  name="user_form"
                  onFinish={onFormItemSubmit}
                >
                  <Form.Item
                    label={translation(translationCache, 'Item')}
                    name={'Item'}
                    rules={[{ required: true }]}
                  >
                    <InputComponent
                      placeholder={translation(translationCache, 'Please enter Item')}
                    />
                  </Form.Item>
                </Form>
              </Modal>
              <Modal
                open={visible}
                width={800}
                closable
                title={translation(translationCache, constant.selectEquipment)}
                onOk={onModalOk}
                onCancel={onDrawerCancel}
                bodyStyle={{ padding: '20px' }}
                style={{ maxWidth: '90vw', width: '400px' }}
              >
                <TableSelect
                  data={deviceList}
                  translationCache={props.translationCache}
                  key="Equipment"
                  columns={[
                    {
                      title: translation(translationCache, 'Equipment'),
                      dataIndex: 'DisplayCode',
                      key: 'DisplayCode',
                      ...getColumnSearchProps('DisplayCode')
                    },
                    {
                      title: translation(translationCache, 'Equipment Description'),
                      dataIndex: 'Name',
                      key: 'Name',
                      ...getColumnSearchProps('Name')
                    }
                  ]}
                  handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
                />
              </Modal>
              <Modal
                title={translation(translationCache, constant.addArea)}
                open={viewAreaModal}
                okText={'Save'}
                onOk={onFormAreaSubmit}
                onCancel={onAreaClose}
                bodyStyle={{ padding: '20px' }}
                style={{ maxWidth: '90vw', width: '400px' }}
              >
                <Form
                  layout="vertical"
                  ref={areaRef}
                  name="user_form"
                  onFinish={onFormAreaSubmit}
                >
                  <Form.Item
                    label={translation(translationCache, constant.area)}
                    name={'Area'}
                    rules={[{ required: true }]}
                  >
                    <InputComponent
                      placeholder={translation(translationCache, 'Enter Area')}
                    />
                  </Form.Item>
                </Form>
              </Modal>
              <Modal
                title={translation(translationCache, 'Add Question')}
                open={viewQuestionModal}
                okText={'Save'}
                width={700}
                onOk={onModalFormSubmit}
                onCancel={onQuestionsClose}
                bodyStyle={{ padding: '20px' }}
                style={{ maxWidth: '90vw', width: '400px' }}
              >
                <Form
                  ref={deviceRef}
                  name="user_form"
                  layout="vertical"
                  labelAlign="right"
                  labelWrap
                >
                  <Form.Item
                    label={translation(translationCache, 'Add Question')}
                    name={'Question'}
                    rules={[{ required: true }]}
                  >
                    <InputComponent
                      onChange={(e) => onAnswerChange(e)}
                      placeholder={translation(translationCache, 'Add Question')}
                    />
                  </Form.Item>
                  <Form.List name="Answers">
                    {(Answers, { add }) => (
                      <>
                        <Form.Item>
                          <Button
                            disabled={AnswerList.length === 0}
                            onClick={() => add()}
                            icon={<PlusOutlined />}
                          >
                            {translation(translationCache, 'Add Answers')}
                          </Button>
                        </Form.Item>
                        {Answers.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col   span={12}>
                              <Form.Item
                                {...restField}
                                label={translation(translationCache, 'Answer')}
                                name={[name, 'Option']}
                                rules={[{ required: true }]}
                              >
                                <Select
                                  value={formObjectQuestions?.Answers || []}
                                  placeholder={translation(translationCache, 'Select Answer')}
                                  onChange={onAnswerChange}
                                  showArrow={true}
                                >
                                  {AnswerList &&
                                    Array.isArray(AnswerList) &&
                                    AnswerList.map((answers, index) => (
                                      <Option
                                        key={index}
                                        value={answers.Id}
                                        disabled={
                                          deviceRef.current &&
                                          deviceRef.current.getFieldsValue() &&
                                          deviceRef.current.getFieldsValue()['Answers'] &&
                                          deviceRef.current.getFieldsValue()['Answers'][index] &&
                                          deviceRef.current.getFieldsValue()['Answers'][index]['Option'] === answers.Id
                                        }
                                      >
                                        {translation(props.translationCache, answers.Answer)}
                                      </Option>
                                    ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col   span={12}>
                              <Form.Item
                                {...restField}
                                label={translation(translationCache, 'Select WorkPlan')}
                                name={[name, 'Actions']}
                                rules={[{ required: false }]}
                              >
                                <Select
                                  placeholder={translation(translationCache, 'Select WorkPlan')}
                                  mode="multiple"
                                  showArrow={true}
                                >
                                  {WorkPlanList &&
                                    Array.isArray(WorkPlanList) &&
                                    WorkPlanList.map((answers, index) => (
                                      <Option key={index} value={answers.Code}>
                                        {translation(translationCache, answers.Name)}
                                      </Option>
                                    ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Form>
              </Modal>
            </div>
          </div>
        </Tooltip>
      </div>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.loggedInProfile,
});

export default connect(mapStateToProps)(QuestionMasterForm);